// @flow
export { default } from './CategorySubItem';



// WEBPACK FOOTER //
// ./src/components/categories/CategorySubItem/index.js